import * as React from 'react';
import { classnames } from 'helpers/utils/classnames';
import { SectionProps } from './types';
import { highlight } from '../../utils/highlight';
import Cell from '../cell';
import Grid from '../grid';
import TasticWrapper from '../tastic-wrapper';

const sectionsClassNames: Record<string, string> = {
  head: '',
  main: 'grow body-section',
  footer: '',
};

/**
 * Renders one Studio page section (head/main/footer) as a `Grid` of
 * `Cell`s/tastics. Exported on its own (not only used internally by
 * `Renderer`) so a route can render individual Studio-driven sections next
 * to non-Studio content — e.g. the homepage keeps Studio's `head`/`footer`
 * chrome but substitutes `main` with Storyblok content (ADR-024).
 */
const Section = ({
  section,
  dataSources,
  params,
  searchParams,
  categories,
  flattenedCategories,
  currentHighlight,
  gridClassName = '',
  wrapperClassName = '',
}: SectionProps) => {
  if (!section) return null;

  return (
    <Grid
      gridClassName={gridClassName}
      wrapperClassName={classnames(
        'relative w-full',
        wrapperClassName,
        highlight(currentHighlight === section.sectionId),
        sectionsClassNames[section.sectionId ?? ''],
      )}
    >
      {section.layoutElements?.map((layoutElement) => (
        <Cell
          key={layoutElement.layoutElementId}
          configuration={layoutElement.configuration}
          isHighlighted={currentHighlight === layoutElement.layoutElementId}
        >
          {layoutElement.tastics.map((tastic) => (
            <TasticWrapper
              key={tastic.tasticId}
              data={tastic}
              params={params}
              searchParams={searchParams}
              dataSources={dataSources}
              isHighlighted={currentHighlight === tastic.tasticId}
              categories={categories}
              flattenedCategories={flattenedCategories}
            />
          ))}
        </Cell>
      ))}
    </Grid>
  );
};

export default Section;
